// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3f358cab","160":"87094740","208":"4b5e2b1e","293":"e06f636b","516":"60861a54","519":"72651389","840":"ab2ce905","917":"899a0d7e","946":"b424a837"}[chunkId] + ".chunk.js";
};